import './Textarea.scss'
import type { ChangeEvent, ComponentProps, CSSProperties } from 'react'
import { clx } from '../clx'

export interface TextareaProps extends Omit<
  ComponentProps<'textarea'>,
  'value' | 'defaultValue' | 'onChange'
> {
  value?: string
  defaultValue?: string
  onChange?: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void
  /** Visible lines (the minimum when auto-resizing). Default 3. */
  rows?: number
  /** Grow with the content up to `maxRows` (CSS field-sizing; falls back to `rows`). */
  isAutoResize?: boolean
  /** Upper bound for auto-resize, in lines. Default 12. */
  maxRows?: number
}

/** Multi-line text input. Spread Field's control props onto it. */
export function Textarea({
  rows = 3,
  isAutoResize = false,
  maxRows = 12,
  onChange,
  className,
  style,
  ref,
  ...rest
}: TextareaProps) {
  const sizing = isAutoResize
    ? ({ '--textarea-rows': rows, '--textarea-max-rows': Math.max(rows, maxRows) } as CSSProperties)
    : undefined

  return (
    <textarea
      {...rest}
      ref={ref}
      rows={rows}
      style={sizing || style ? { ...sizing, ...style } : undefined}
      className={clx('textarea', isAutoResize && 'textarea--is-auto-resize', className)}
      onChange={(event) => onChange?.(event.target.value, event)}
    />
  )
}
